const coordinatorValidate = levels => {
  const errors = {}
  const message = 'Informe ao menos um nível de ensino para prosseguir'
  const values = Object.values(levels)

  if (!levels || !values.length || !values.some(level => level)) {
    errors.levels = message
  }

  return errors
}

export default coordinatorValidate
